import { createClient } from '@supabase/supabase-js'
import config from './config'

// Initialize the Supabase client using our config file
// This provides more reliable access to configuration than direct env vars
const supabaseUrl = config.supabase.url;
const supabaseAnonKey = config.supabase.anonKey;

// Validate configuration - this should now always be available through our config
if (!supabaseUrl || !supabaseAnonKey) {
  console.error('Supabase configuration is missing. Authentication will not work properly.');
}

// Create a single supabase client for the entire app
const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  }
});

export default supabase;
